import { render, staticRenderFns } from "./MainViewVer.vue?vue&type=template&id=1b6024e5"
import script from "./MainViewVer.vue?vue&type=script&lang=js"
export * from "./MainViewVer.vue?vue&type=script&lang=js"
import style0 from "./MainViewVer.vue?vue&type=style&index=0&id=1b6024e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports